import { makeAutoObservable } from 'mobx'

export const maxRequestFormTexts = {
  title: 'Ваша запрос отправлен',
  subDescription: 'Ожидайте, скоро с вами свяжется наш менеджер',
  description:
    'Пока менеджер готовит ответ, вы можете начать работу в боте и найти информацию уже сейчас!',
}

export const maxSubscribeTexts = {
  title: 'Подписка оформлена',
  subDescription: null,
  description: 'Ещё больше информации вы сможете получить в нашем боте MAX',
}

class MaxPopupStore {
  isVisible: boolean = false

  sourceSite: string = ''

  title: string = ''
  subDescription: string | null = null
  description: string = ''

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  show({
    sourceSite,
    title,
    subDescription,
    description,
  }: {
    sourceSite: string
    title: string
    subDescription: string | null
    description: string
  }) {
    this.title = title
    this.subDescription = subDescription ?? null
    this.description = description
    this.sourceSite = sourceSite

    this.isVisible = true
  }

  hide() {
    this.isVisible = false

    this.sourceSite = ''
    this.title = ''
    this.subDescription = null
    this.description = ''
  }
}

export const maxPopupStore = new MaxPopupStore()
